import { render, staticRenderFns } from "./BaseActionDocumentManager.vue?vue&type=template&id=57ce9b44&"
import script from "./BaseActionDocumentManager.vue?vue&type=script&lang=ts&"
export * from "./BaseActionDocumentManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports